import { Link } from "react-router-dom";
import { Leaf, Mail, Phone, MapPin } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="bg-primary text-primary-foreground mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-full bg-primary-foreground/15 grid place-items-center">
                <Leaf className="w-4 h-4" />
              </span>
              <span className="font-serif text-2xl">Aarkays Consultancy</span>
            </div>
            <p className="text-sm leading-relaxed opacity-80">
              Helping families build and protect wealth since 2008. We don't just manage your money —
              we help you manage your behaviour so you can make the right decisions.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] opacity-60 mb-4">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:underline opacity-90">Home</Link></li>
              <li><Link to="/calculators" className="hover:underline opacity-90">Calculators</Link></li>
              <li><Link to="/quiz" className="hover:underline opacity-90">Finance Quiz</Link></li>
              <li><a href="/#process" className="hover:underline opacity-90">Our Research</a></li>
              <li><a href="/#contact" className="hover:underline opacity-90">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] opacity-60 mb-4">Reach Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 opacity-70" /> +91 98207 02899</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 opacity-70" /> riddhishah2142@gmail.com</li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 opacity-70 mt-0.5 shrink-0" />
                <span className="leading-relaxed">
                  D-508, 5th Floor, Zee Shaan,<br />
                  Zee Corporate Park, M.G. Road,<br />
                  Vile Parle (East), Mumbai 400 057
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-primary-foreground/15 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs opacity-70">
          <p>© {new Date().getFullYear()} Aarkays Consultancy. AMFI Registered Mutual Fund Distributor.</p>
          <p className="max-w-2xl">
            Mutual fund investments are subject to market risks. Please read all scheme related documents carefully.
            Past performance is not indicative of future returns.
          </p>
        </div>
      </div>
    </footer>
  );
}
